export default __webpack_public_path__ + "static/media/pic4.06656a01.jpg";